export const PUMP_ITEMS = [
  0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12,
];

export const PUMP_ITEMS_INTEGER = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
